import React from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// css
import './lib/SignUpCss.js';
//signup 
import Signup from './Routes/Signup/Signup';
import * as serviceWorker from './serviceWorker';

const FontAwesomeCloseButton = ({ closeToast }) => (
   <i className="toastify__close fas fa-times Toastify__close-button" onClick={closeToast}></i>
);

ReactDOM.render(
   <>
      <Signup />
      <ToastContainer closeButton={<FontAwesomeCloseButton />} transition={Slide} autoClose={3000} hideProgressBar={true} position={toast.POSITION.TOP_RIGHT} />
   </ >, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();